import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const SchematicEditorElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Schematic Editor',
  icon: 'MenuAlt3Icon',
  description: 'Adds a schematic editor (cad) designer element',
  properties: [
    {
      label: 'Schematic Name',
      name: 'componentName',
      editor: 'textbox',
      default: '',
      description: 'The name of the schematic component',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Image Destination Field',
      name: 'imageField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that will be used to store a picture of the schematic',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Schematic Destination Field',
      name: 'schematicField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that store the data associated with the schematic',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Image Storage Path',
      name: 'storagePath',
      editor: 'textbox',
      description: 'The firebase storage path to store the schematic image in',
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Title',
      name: 'text',
      editor: 'textbox',
      default: '',
      description: 'The title to pass along to the component',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'margin',
    'padding'
  ]
};

export default SchematicEditorElementFields;
